import type { InstitutionTheme } from '../types';
import { sjsuColors } from './colors';

// SJSU institutional theme.
//
// Brand strings sourced from sjsu.edu (official university name with
// é accent; "MySJSU" as the student/registration portal name per
// sjsu.edu/registrar usage). Colors per ./colors.ts (Pantone 300C blue
// + 124C gold).
//
// Example course codes vetted against the SJSU CS BS catalog (workstream
// B1, 2026-05-11). Order matches the backend prompt fragment
// (backend/services/prompts/institutions/sjsu.py): CS 146 (Data Structures
// and Algorithms — major core), ENGL 1A (First-Year Writing — A2/1A area),
// MATH 30 (Calculus I). First entry is the primary single-example shown in
// placeholder text.
export const sjsuTheme: InstitutionTheme = {
  slug: 'sjsu',
  universityName: 'San José State University',
  universityShortName: 'SJSU',
  registrationPortalName: 'MySJSU',
  exampleCourseCodes: ['CS 146', 'ENGL 1A', 'MATH 30'],
  colors: sjsuColors,
};
